export default __webpack_public_path__ + "static/media/kia.0de8bdad.svg";